<svelte:head>
<meta name="robots" content="no-index">
</svelte:head>
<script>
  import { Card } from "flowbite-svelte";
  import InfoCard from '$lib/info_card.svelte'
  // note both nathan transformed and this one are same size lmao
  let nathan = new URL("$lib/assets/images/nathan-2-transformed.png", import.meta.url)
  let philippe = new URL("$lib/assets/images/sexy-philippe-transformed.png", import.meta.url)
  let wade =  new URL("$lib/assets/images/wade-transformed.png", import.meta.url)
</script>
<div class="outer">
<section><p>
 We are educators and technologists who are driven by learning. We understand the challenges in educating tomorrow’s leaders and are devoted to reducing the barriers to make Science, Engineering, and Math education attainable.
</p> </section>
  <InfoCard src={nathan} w="300" h="264">

    <p>
      Tagline: Don't forget to LSD (learn something dangerous)!
    </p>

  </InfoCard>

  <div class="inner">
    <h3>Nathan Fox</h3>
    <h3>Chief Engineering Officer</h3>
  </div>
  <p>
    Nathan's coding journey began at eleven with C++, aimed at streamlining life's tedious tasks. Though passionate
    about Physics, Math, and Computer Science, he chose to study Chemistry in undergrad for its challenge and
    pedagogical unsoundness. Due to his interests he ended up in Graduate School studying Theoretical Chemistry
    (a.k.a. Heretical Chemistry) for which he used Deep Neural Networks to simulate interesting materials.
  </p>

<InfoCard src={philippe} w="300" h="312">
  <p>

  </p>
  <p>
    Tagline: But I think it can be completed more quickly using [method].
  </p>
</InfoCard>
<div class="inner">
  <h3>Philippe David</h3>
  <h3>Chief AI Officer</h3>
</div>
  <div>
<p>
  Philippe's journey into computing began at twelve, rooted in an early fascination with robotics.
</p>
<p>
  Starting college at 15 at Bethel College, his academic path veered into Chemistry at the University of Utah, where his collaboration with Nathan began.
</p>
<p>
  Despite being an undergraduate, Philippe's engagement in graduate-level work catalyzed a fast friendship with Nathan.
</p>
<p>
  Post-graduation, Philippe's career took him from Google in 2019 to a new chapter at edup
</p>
  </div>
<InfoCard src={wade} w="300" h="300">

  <p>
    Tagline: It's better than good; it's good enough.
  </p>
</InfoCard>
  <div class="inner">
  <h3>Dr. Wade Johnson</h3>
<h3>Chief Academic Officer</h3>
  </div>

  <p>
Dr. Wade Johnson has been an active educator and prolific researcher for over 25 years. His diverse training has resulted in developing courses ranging from scientific ethics, alternative energy fuels, advanced biochemistry, and novel student-driven laboratories. He has developed interdisciplinary majors and supervised state funded outreach programs bringing modern technology into rural under-resourced high schools, in addition to leading two academic departments. His overarching goal has always been to remove barriers in STEM learning and give students the confidence and tools to be successful.
 <p>

 </p>

</div>

<style>
    section{
      margin-top:2em;
    }
   .outer {
     display: flex;
     gap: 3vw;
     align-items: center;
     justify-content: center;
     /*height: 100vh;*/
     flex-direction: column;
     width: 80vw; /* Adjust width to account for the margins */
     margin-left: 10vw;
     margin-right: 10vw;
   }
  .inner {
    display: flex;
    /*gap: 3vw;*/
    align-items: center;
    justify-content: center;
    /*height: 100vh;*/
    flex-direction: column;
    width: 80vw; /* Adjust width to account for the margins */
    margin-left: 10vw;
    margin-right: 10vw;
  }

  p{
    max-width:500px;
    margin-bottom: 2em;
  }
</style>














